<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <div class="entityView">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
    </v-container>
</template>
<script>
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
import permissionsSet from '../../components/permissions'
const entity = 'rumour'
export default {
    name: 'RumourHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'List', icon: 'mdi-view-list', to: 'rumour' },
                { title: 'Archive', icon: 'mdi-delete-outline', to: 'rumourArchive' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newRumour' }, ...items]
            if (this.canPrint) items = [...items, { title: 'Print', icon: 'mdi-plus', to: 'printRumours' }]
            return items
        },
        canCreate() {
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
        canPrint() {
            if (this.user && this.user[entity]) {
                return this.user[entity].all.includes(permissionsSet.Read)
            } else {
                return false
            }
        },
    },
}
</script>
<style>
.entityView {
    width: 100%;
}
</style>
